import { WrongNetworkNotification } from "./BlockchainNotifications";

export const ShellNotifications = {
  Blockchain: {
    WrongNetworkNotification,
  },
};
